import { NotificationState } from './types';
// eslint-disable-next-line import/prefer-default-export
export const getNotificationsSelector = ({
  notifications,
}): NotificationState => notifications;
